// @flow
import { treeActionTypes as Types } from '../constants';

export const selectNode = (nodeId: number) => ({
  type: Types.SELECT_NODE,
  payload: {
    nodeId
  }
});

export const deselectNode = () => ({
  type: Types.DESELECT_NODE
});

export const startDeletingNode = () => ({
  type: Types.START_DELETING_NODE
});

export const stopDeletingNode = () => ({
  type: Types.STOP_DELETING_NODE
});

export const clearTree = () => ({
  type: Types.CLEAR_TREE
});



// WEBPACK FOOTER //
// ./src/actions/tree.js